export enum Type {
  GIFS_GET_REQUEST = 'app/gif-search/GIFS_GET_REQUEST',
  GIFS_GET_SUCCESS = 'app/gif-search/GIFS_GET_SUCCESS',
  GIFS_GET_FAILURE = 'app/gif-search/GIFS_GET_FAILURE',

  GIF_SEARCH_RESULTS_CLEAR = 'app/gif-search/GIF_SEARCH_RESULTS_CLEAR',
  GIF_SEARCH_RESULTS_CLEAR_ALL = 'app/gif-search/GIF_SEARCH_RESULTS_CLEAR_ALL',
}
